jQuery(function ($) {
   $('.site-header__search-toggle').click(function(e){
     $('html,body').addClass('js-drawer-open js-drawer-open-top');
   });
   $('.search-bar__close').click(function(e){
     $('html,body').removeClass('js-drawer-open js-drawer-open-top');
   });
   $('.sguide').on('click',function(){
          	$('.sizeguide').addClass('active');
            $('body').addClass('size-active');
          });
          $('.closeModal').on('click',function(e){
            e.preventDefault();

            $('.sizeguide').removeClass('active');
            $('body').removeClass('size-active');
            
          });
  
  $('.toggle-menu').click(function(e){
    e.preventDefault();
    $('.account-menu').slideToggle();
    
  });
   
    if (typeof $.fn.slick === "function") {
        $(".js-heading-slider").slick({
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            autoplay: true,
            dots: true,
        });
        $(".js-partners-slider").slick({
            arrows: false,
            slidesToShow: 6,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                        autoplay: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        autoplay: true,
                    }
                },,
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 3,
                        autoplay: true,
                    }
                },
            ]
        });
    }
  
    $(".morelink").click(function(e) {
      e.preventDefault();
      return $(this).hasClass("less") ? ($(this).removeClass("less"), $(".more").slideUp(), $(this).html("More")) : ($(this).addClass("less"), $(".more").slideDown(), $(this).html("Less"))
    });

    // mobile menu
    $(".menu-toggle").click(function (){
        $("body").toggleClass("mob-menu-open");
    });

    // Page Scrolling
    $("a[href^='#target']").click(function (e) {
        e.preventDefault();
        const elementClick = $(this).attr("href");
        if($(elementClick).length){
            $('body,html').animate({
                scrollTop: $(elementClick).offset().top
            }, 600);
        }
    });

    // footer accordion
    const breakpoint = 767;
    if($(window).width() <= breakpoint){
        $(".footer-widgetarea .widget ul").hide();
    }else{
        $(".footer-widgetarea .widget ul").show();
    }
    $(window).resize(function(){
        if($(this).width() <= breakpoint){
            $(".footer-widgetarea .widget ul").hide();
            $(".footer-widgetarea .widget h5").removeClass("is-active");
        }else{
            $(".footer-widgetarea .widget ul").show();
        }
    });
    $(".footer-widgetarea .widget h5").click(function(){
        if($(window).width() <= breakpoint){
            $(this).toggleClass("is-active");
            $(this).next("ul").slideToggle();
        }
    });
});
